
import { useState, useEffect } from "react";

export const useViewManager = () => {
  const [currentView, setCurrentView] = useState("home");

  useEffect(() => {
    setCurrentView("home");
  }, []);

  const handleShowAllVacations = () => {
    setCurrentView("all");
  };

  const handleShowDeals = () => {
    setCurrentView("deals");
  };

  const handleShowLuxury = () => {
    setCurrentView("luxury");
  };

  const handleShowRondreizen = () => {
    setCurrentView("rondreizen");
  };

  const handleGoHome = () => {
    setCurrentView("home");
  };

  const handleGoBack = () => {
    setCurrentView("home");
  };

  return {
    currentView,
    setCurrentView,
    handleShowAllVacations,
    handleShowDeals,
    handleShowLuxury,
    handleShowRondreizen,
    handleGoHome,
    handleGoBack
  };
};
